import request from '@/utils/httpRequest'

export default class StagingService {
    queryById(id) {
        return request({
            url: '/shye/finance/shyeFinanceReceivableStaging/queryById',
            method: 'get',
            params: { id: id }
        })
    }

    list (params) {
        return request({
            url: '/shye/finance/shyeFinanceReceivableStaging/getDeratedList',
            method: 'get',
            params: params
        })
    }

    startFlow (params) {
        return request({
            url: '/shye/finance/shyeFinanceReceivableStaging/startFlow',
            method: 'post',
            data: params
        })
    }
}